import ReactDOM from "react-dom";
import { useState, useEffect, useRef, useContext } from "react";
import { useParams } from "react-router-dom";
import FullCalendar from "@fullcalendar/react";
// import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import ptLocale from "@fullcalendar/core/locales/pt";

import { AuthContext } from "../../../../shared/context/auth-context";
import { ClinicaContext } from "../../../../shared/context/clinica-context";
import { useHttpClient } from "../../../../shared/hooks/http-hook";

import AppointmentForm from "./componentsFullCallendar/AppointmentForm";
import Tooltip from "./componentsFullCallendar/Tooltip";
import ModalInfo from "../../../../shared/components/UIElements/ModalInfo";
import DialogoConfirmacaoAgendamento from "../../../../shared/components/confirmacaoPresenca/DialogoConfirmacaoAgendamento";
import MoveAppointmentDialog from "./componentsFullCallendar/MoveAppointmentDialog";
import ConflictResolutionDialog from "./componentsFullCallendar/ConflictResolutionDialog";

import { isDateTimeAvailable } from "../../../../shared/util/disponibilidadeCheck";

import moment from "moment";
import "./Datatable.scss";

import { useLoading } from "../../../../shared/context/LoadingContext";
import toast from "react-hot-toast";
import SeletorUnidadeDados, {
  TODAS_UNIDADES,
} from "../../../../shared/components/badgeUnidade/SeletorUnidadeDados";
import {
  queryUnidadeDados,
  podeAlterarRegisto,
  motivoBloqueioUnidade,
} from "../../../../shared/util/unidadeRegisto";

const getFirstAndLastName = (fullName) => {
  if (!fullName) return "";
  const names = fullName.trim().split(" ");
  if (names.length === 1) return names[0];
  return `${names[0]} ${names[names.length - 1]}`;
};

function Datatable({ medicos }) {
  const { startLoading, stopLoading } = useLoading();

  const [clients, setClients] = useState([]);
  const [clientesProcedimento, setClientesProcedimento] = useState([]);
  const [events, setEvents] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [tooltipEvent, setTooltipEvent] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [allCategoriasTratamento, setAllCategoriasTratamento] = useState([]);
  const [procedimentosPorMarcar, setProcedimentosPorMarcar] = useState([]);
  const [orcamentosPorMarcar, setOrcamentosPorMarcar] = useState([]);
  const [duracaoConsulta, setDuracaoConsulta] = useState(30);
  const [horarioAtendimento, setHorarioAtendimento] = useState({
    start: "08:00:00",
    end: "20:00:00",
  });
  const [disponibilidadeMedico, setDisponibilidadeMedico] = useState(null);

  const [allTratamentos, setAllTratamentosResponse] = useState([]);
  const [nomeMedico, setNomeMedico] = useState();
  const [modalProps, setModalProps] = useState({
    show: false,
    icon: "",
    title: "",
    message: "",
    form: false,
  });

  /* Mexer numa marcação JÁ CONFIRMADA pára aqui à espera de resposta.
     `{ modo, nomeCliente, prosseguir(manterConfirmacao), cancelar() }` — a
     ação fica guardada numa função para o diálogo a poder correr depois,
     com ou sem o ✓, conforme o que a pessoa escolher. */
  const [confirmacaoEmRisco, setConfirmacaoEmRisco] = useState(null);

  const clickRef = useRef(null);
  const tooltipRef = useRef(null);

  const { sendRequest } = useHttpClient();

  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);
  const medicoId = useParams().medicoId;

  /* De que unidade são as marcações desta agenda. Arranca na da sessão. */
  const [unidadeDados, setUnidadeDados] = useState(
    () => auth.estabelecimento?._id ?? null,
  );
  const verTodasUnidades = unidadeDados === TODAS_UNIDADES;

  /* Os parâmetros de unidade em query string, porque a agenda é um GET.
     A decisão vive no helper partilhado: era daqui que estava copiada, e a
     cópia que faltava nas listas de atendimento foi o que deixou os
     compromissos sem filtro. */
  const qsUnidade = (jaTemQuery) =>
    queryUnidadeDados(unidadeDados, auth, jaTemQuery);

  const [moveDialogOpen, setMoveDialogOpen] = useState(false);
  const [selectedEventToMove, setSelectedEventToMove] = useState(null);

  //Conflit resolution de mover agendamento
  const [conflictDialogOpen, setConflictDialogOpen] = useState(false);
  const [conflictData, setConflictData] = useState(null);
  const [pendingMoveData, setPendingMoveData] = useState(null);

  //Agendamentos antigos
  const [loadOldAppointments, setLoadOldAppointments] = useState(false);
  const [showLoadOldButton, setShowLoadOldButton] = useState(false);
  const previousRangeRef = useRef(null);
  const calendarRef = useRef(null);
  const savedDateRef = useRef(null);

  //lista espera
  const [listaEsperaContagem, setListaEsperaContagem] = useState(null);
  const [listaEspera, setListaEspera] = useState([]);
  const [listaEsperaDeleteDialog, setListaEsperaDeleteDialog] = useState({
    show: false,
    event: null,
  });
  // Container do portal do badge da lista de espera (toolbar do FullCalendar).
  // Capturado num estado após o commit para evitar a race condition de
  // procurar o elemento no DOM durante o render (o toolbar pode ainda não existir).
  const [listaEsperaPortalEl, setListaEsperaPortalEl] = useState(null);

  // Captura o container do toolbar do FullCalendar onde o badge da lista de
  // espera é injetado (via portal). Corre após o commit e faz algumas
  // tentativas, pois o FullCalendar renderiza o toolbar de forma assíncrona.
  // Sem isto, o badge só aparecia "algumas vezes" (quando o querySelector
  // feito durante o render calhava de encontrar o toolbar já montado).
  useEffect(() => {
    if (!events) return undefined;

    let frame;
    let tentativas = 0;

    const capturarToolbar = () => {
      const el = document.querySelector(".fc-toolbar-chunk:last-child");
      if (el) {
        setListaEsperaPortalEl((prev) => (prev === el ? prev : el));
      } else if (tentativas < 10) {
        tentativas += 1;
        frame = requestAnimationFrame(capturarToolbar);
      }
    };

    frame = requestAnimationFrame(capturarToolbar);

    return () => {
      if (frame) cancelAnimationFrame(frame);
    };
  }, [events]);

  // Handler
  const handleMoverAgendamento = (event) => {
    setSelectedEventToMove(event);
    setMoveDialogOpen(true);
  };

  useEffect(() => {
    setEvents([]);
    const fetchData = async () => {
      try {
        let disponibilidadeLocal = null;
        let horarioAtendimentoLocal = {
          start: "08:00:00",
          end: "20:00:00",
        };
        //Duracao de consulta e horario de atendimento
        if (medicos) {
          let temp = medicos.find((m) => m.id === medicoId);
          setNomeMedico(temp.nome);
          if (temp.duracaoConsulta) setDuracaoConsulta(temp.duracaoConsulta);

          if (temp.horarioAtendimento) {
            horarioAtendimentoLocal = temp.horarioAtendimento;
            setHorarioAtendimento(temp.horarioAtendimento);
          }

          if (temp.disponibilidade) {
            disponibilidadeLocal = temp.disponibilidade;
            setDisponibilidadeMedico(temp.disponibilidade);
          }
        } else {
          //Caso Role Dentista
          const response = await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/users/${medicoId}`,
            "GET",
            null,
            {
              Authorization: "Bearer " + auth.token,
            },
          );

          setNomeMedico(response.user.name);
          if (response.user.horarioAtendimento) {
            horarioAtendimentoLocal = response.user.horarioAtendimento;
            setHorarioAtendimento(response.user.horarioAtendimento);
          }

          if (response.user.disponibilidade) {
            disponibilidadeLocal = response.user.disponibilidade;
            setDisponibilidadeMedico(response.user.disponibilidade);
          }

          if (response.user.duracaoConsulta)
            setDuracaoConsulta(response.user.duracaoConsulta);
        }

        startLoading();
        const formData = new FormData();
        formData.append("medicoId", medicoId);

        const formDataListaEspera = new FormData();
        formDataListaEspera.append("clinicaId", clinica.clinica._id);

        const [
          proceduresResponse,
          orcamentosResponse,
          tratamentoIsoladosResponse,
          agendaResponse,
          agendamentosProvisoriosResponse,
          compromissosResponse,
          agendamentosEmTransicaoResponse,
          clientesResponse,
          categoriasTratamentoResponse,
          tratamentosResponse,
          listaEsperaResponse,
        ] = await Promise.all([
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/procedimentos/agenda/${clinica.clinica._id}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/orcamentos/agenda/orcamentosnaoaprovados/${clinica.clinica._id}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${
              process.env.REACT_APP_BACKEND_LINK
            }/api/tratamentoIsolados/agenda/${clinica.clinica._id}${
              loadOldAppointments ? "?loadOld=true" : ""
            }${qsUnidade(loadOldAppointments)}`,
            "PATCH",
            formData,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/agenda/${medicoId}${
              loadOldAppointments ? "?loadOld=true" : ""
            }${qsUnidade(loadOldAppointments)}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/agendamentosprovisorio/agenda/${medicoId}${qsUnidade(false)}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${
              process.env.REACT_APP_BACKEND_LINK
            }/api/compromissos/${medicoId}${
              loadOldAppointments ? "?loadOld=true" : ""
            }${qsUnidade(loadOldAppointments)}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/agendamentosemtransicao/${medicoId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/clientes/agendaavaliacao/${clinica.clinica._id}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/categoriastratamento/clinica/${clinica.clinica._id}`,
            "GET",
            null,
            {
              Authorization: "Bearer " + auth.token,
            },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentos/agendatratamento/clinica/${clinica.clinica._id}`,
            "GET",
            null,
            {
              Authorization: "Bearer " + auth.token,
            },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/listaespera/medico/${medicoId}`,
            "POST",
            formDataListaEspera,
            { Authorization: "Bearer " + auth.token },
          ),
        ]);

        const agendamentosProvisorios =
          agendamentosProvisoriosResponse.agendamentos || [];
        const agendaMarcacoes = agendaResponse.agenda || [];
        const compromissosMarcacoes = compromissosResponse.compromissos || [];
        const tratamentoIsoladosMarcacoes =
          tratamentoIsoladosResponse.tratamentoIsolados || [];
        const agendamentosEmTransicaoMarcacoes =
          agendamentosEmTransicaoResponse.agenda || [];
        setClients(clientesResponse.clientes);
        setAllCategoriasTratamento(
          categoriasTratamentoResponse.categoriasTratamento.map((c) => ({
            id: c._id,
            label: c.categoria,
          })),
        );

        //lista de espera
        setListaEsperaContagem(listaEsperaResponse.contagem);
        setListaEspera(listaEsperaResponse.listaEspera);

        const tratamentosOrdenadosAlfabeticamente =
          tratamentosResponse.tratamentos.sort((a, b) =>
            a.designacao.trim().localeCompare(b.designacao.trim()),
          );

        const tempTratamentosAutocomplete =
          tratamentosOrdenadosAlfabeticamente.map((t) => ({
            id: t._id,
            label: t.fornecedor?.nome
              ? `${t.designacao.trim()} (${t.fornecedor.nome})`
              : t.designacao.trim(),
          }));

        setAllTratamentosResponse(tempTratamentosAutocomplete);

        const formattedEvents = [
          ...formatAppointments(agendaMarcacoes),
          ...formatCompromissos(compromissosMarcacoes),
          ...formatTransitionAppointments(agendamentosEmTransicaoMarcacoes),
          ...formatTratamentoIsolados(tratamentoIsoladosMarcacoes),
          ...formatAgendamentosProvisorio(agendamentosProvisorios),
          ...formatExcecoes(disponibilidadeLocal, horarioAtendimentoLocal),
          ...formatPeriodosEspeciaisBackground(
            disponibilidadeLocal,
            horarioAtendimentoLocal,
          ),
        ];

        const tempClientes = [];
        const tempData = [];
        const tempDataOrcamentos = [];

        //Procedimentos por marcar
        try {
          proceduresResponse.planosTratamento.forEach((pl) => {
            if (pl.status === "INTERROMPIDO") return;
            pl.procedimentos.forEach((pr) => {
              tempData.push({
                id: crypto.randomUUID(),
                id_plano: pl.id,
                orcamento: false,
                cliente: {
                  id: pl.cliente._id,
                  label: pl.cliente.nome,
                },
                startDate: pr.data_inicio_execucao
                  ? new Date(pr.data_inicio_execucao)
                  : null,
                endDate: pr.data_fim_execucao
                  ? new Date(pr.data_fim_execucao)
                  : null,
                title:
                  pl.cliente.nome + " - " + pr.tratamento.categoria.categoria,
                procedimento: {
                  id: pr.tratamento.categoria._id,
                  label: pr.tratamento.categoria.categoria,
                },
                filaEspera: false,
                atendido: false,
                faltou: false,
                emTransicao: false,
              });
            });

            if (pl.procedimentos.length > 0) {
              // We only check if the client ID doesn't exist in our array yet
              if (
                tempClientes.filter((c) => c.id === pl.cliente._id).length === 0
              ) {
                const existemProcedimentosDoClientePorMarcar =
                  pl.procedimentos.filter(
                    (pr) => !pr.data_inicio_execucao,
                  ).length;

                if (existemProcedimentosDoClientePorMarcar) {
                  tempClientes.push({
                    id: pl.cliente._id,
                    label: pl.cliente.nome,
                  });
                }
              }
            }
          });

          orcamentosResponse.orcamentos.forEach((orc) => {
            orc.procedimentos.forEach((pr) => {
              tempDataOrcamentos.push({
                id: crypto.randomUUID(),
                orcamento: true,
                id_orcamento: orc.id, // Diferencia-se do id_plano
                cliente: {
                  id: orc.cliente._id,
                  label: orc.cliente.nome,
                },
                startDate: null, // Como ainda não foi iniciado
                endDate: null,
                title:
                  orc.cliente.nome +
                  " - " +
                  (pr.tratamento?.categoria?.categoria ?? "Procedimento"),
                procedimento: {
                  id: pr.tratamento?.categoria?._id ?? null,
                  label: pr.tratamento?.categoria?.categoria ?? "Desconhecido",
                },
                filaEspera: true, // Marcar como em espera
                atendido: false,
                faltou: false,
                emTransicao: false,
              });
            });

            if (orc.procedimentos.length > 0) {
              // Só adiciona se ainda não está na lista
              if (tempClientes.every((c) => c.id !== orc.cliente._id)) {
                tempClientes.push({
                  id: orc.cliente._id,
                  label: orc.cliente.nome,
                });
              }
            }
          });
        } catch (err) {
          console.error("err", err);
        }

        setProcedimentosPorMarcar(tempData);
        setOrcamentosPorMarcar(tempDataOrcamentos);
        setClientesProcedimento(tempClientes);
        setEvents(formattedEvents);
      } catch (err) {
        console.error(err);
      } finally {
        stopLoading();
      }
    };

    fetchData();
    // `unidadeDados` entra aqui: trocar de unidade refaz o pedido.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    sendRequest,
    auth.token,
    clinica.clinica._id,
    medicos,
    medicoId,
    unidadeDados,
  ]);

  // Fetch separado para agendamentos antigos
  useEffect(() => {
    if (!loadOldAppointments) return;

    const fetchOldAppointments = async () => {
      try {
        startLoading();
        const formData = new FormData();
        formData.append("medicoId", medicoId);

        const [
          tratamentoIsoladosResponse,
          agendaResponse,
          compromissosResponse,
        ] = await Promise.all([
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoIsolados/agenda/${clinica.clinica._id}?loadOld=true${qsUnidade(true)}`,
            "PATCH",
            formData,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            /* O `qsUnidade` faltava SÓ aqui — os tratamentos isolados e os
               compromissos, logo acima e logo abaixo, já o levavam. Sem ele o
               servidor cai na unidade da SESSÃO: quem estivesse na Praia a ver
               a agenda da Assomada e carregasse nos antigos recebia os
               tratamentos isolados e os compromissos da Assomada misturados
               com as marcações antigas da Praia. */
            `${process.env.REACT_APP_BACKEND_LINK}/api/agenda/${medicoId}?loadOld=true${qsUnidade(true)}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/compromissos/${medicoId}?loadOld=true${qsUnidade(true)}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
        ]);

        const oldEvents = [
          ...formatAppointments(agendaResponse.agenda || []),
          ...formatCompromissos(compromissosResponse.compromissos || []),
          ...formatTratamentoIsolados(
            tratamentoIsoladosResponse.tratamentoIsolados || [],
          ),
        ];

        // Merge sem duplicados
        setEvents((prev) => {
          const existingIds = new Set(prev.map((e) => e.id));
          const newEvents = oldEvents.filter((e) => !existingIds.has(e.id));
          return [...prev, ...newEvents];
        });
      } catch (err) {
        console.error(err);
      } finally {
        stopLoading();
      }
    };

    fetchOldAppointments();
  }, [loadOldAppointments]);

  /* ─── TROCAR DE UNIDADE RECOMEÇA A AGENDA ──────────────────────────────────
   *
   * O efeito principal volta a pedir tudo e SUBSTITUI os eventos. Os antigos
   * que já estivessem carregados eram da outra unidade e vão nessa
   * substituição — o que está certo.
   *
   * O que faltava era repor o botão. Com o `loadOldAppointments` preso em
   * `true`, ninguém os voltava a pedir sem recarregar a página: a agenda ficava
   * a dizer que os antigos estavam carregados quando já não estavam, e os meses
   * de trás apareciam vazios como se não houvesse lá nada.
   *
   * Não se refaz aqui o pedido dos antigos de propósito: os dois efeitos
   * correriam ao mesmo tempo, e o principal — que substitui, não junta —
   * chegaria depois e apagava-os na mesma. */
  const unidadeJaVista = useRef(unidadeDados);
  useEffect(() => {
    if (unidadeJaVista.current === unidadeDados) return;
    unidadeJaVista.current = unidadeDados;

    if (!loadOldAppointments) return;
    setLoadOldAppointments(false);

    const haUmMes = new Date();
    haUmMes.setMonth(haUmMes.getMonth() - 1);
    setShowLoadOldButton(
      previousRangeRef.current !== null &&
        previousRangeRef.current < haUmMes.getTime(),
    );
  }, [unidadeDados, loadOldAppointments]);

  const handleDatesSet = (dateInfo) => {
    const startTime = dateInfo.start.getTime();

    // Só processa se a data inicial mudou significativamente
    if (previousRangeRef.current !== startTime) {
      previousRangeRef.current = startTime;

      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

      // Só mostra o botão se não carregou ainda e está vendo datas antigas
      if (dateInfo.start < oneMonthAgo && !loadOldAppointments) {
        setShowLoadOldButton(true);
      } else if (dateInfo.start >= oneMonthAgo) {
        setShowLoadOldButton(false);
      }
    }
  };

  // Função para carregar agendamentos antigos
  const handleLoadOldAppointments = () => {
    // Salva a data atual do calendário antes de recarregar
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      savedDateRef.current = calendarApi.getDate();
    }

    setLoadOldAppointments(true);
    setShowLoadOldButton(false);
    toast.success("Carregando agendamentos antigos...");
  };

  useEffect(() => {
    if (loadOldAppointments && savedDateRef.current && calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(savedDateRef.current);
    }
  }, [events]);

  const formatAppointments = (appointments) => {
    return appointments.map((appointment) => ({
      id: appointment._id,
      title: ` ${appointment.cliente?.nome.split(" ")[0]} ${
        appointment.cliente?.nome.split(" ")[
          appointment.cliente?.nome.split(" ").length - 1
        ]
      } - ${
        appointment.avaliacao
          ? "Avaliação"
          : appointment.categoriaTratamento?.categoria
      }`,
      start: new Date(appointment.data_inicio_execucao),
      end: new Date(appointment.data_fim_execucao),

      backgroundColor: appointment.atendido
        ? "#F2FAF5"
        : appointment.faltou
          ? "#FFF3F6"
          : appointment.avaliacao
            ? "#fde6c5"
            : appointment.orcamento
              ? "#E0F7FA"
              : "#ecf6ff",

      borderColor: appointment.atendido
        ? "#39B93A"
        : appointment.faltou
          ? "#D96C60"
          : appointment.avaliacao
            ? "#F57C00"
            : appointment.orcamento
              ? "#0097A7"
              : "#1976D2",

      textColor: appointment.atendido
        ? "#39B93A"
        : appointment.faltou
          ? "#D96C60"
          : appointment.avaliacao
            ? "#F57C00"
            : appointment.orcamento
              ? "#0097A7"
              : "#1976D2",

      extendedProps: {
        clientId: appointment.cliente?._id,
        procedureId: appointment.categoriaTratamento?._id,
        isEvaluation: appointment.avaliacao,
        isAttended: appointment.atendido,
        isMissed: appointment.faltou,
        inTransition: false,
        isCompromisso: false,
        planoId: appointment.planoTratamento,
        orcamentoId: appointment.orcamento,
        isOrcamento: !!appointment.orcamento,
        agendadoPor: appointment.agendadoPor?.name,
        observacoesAgendamento: appointment.observacoesAgendamento,
        listaEsperaId: appointment?.listaEspera || null,
        /* Só o booleano. O servidor já o calcula (`confirmado`) e manda
           exactamente isto — nem data, nem nome de quem confirmou. Esses
           ficam na lista da secretária, onde há espaço para os ler. */
        confirmado: !!appointment.confirmado,
        estabelecimento: appointment.estabelecimento || null,
        codigoUnidade: verTodasUnidades
          ? (appointment.estabelecimento?.codigo ?? null)
          : null,
        nomeUnidade: appointment.estabelecimento?.nome ?? null,
      },
      /* `editable` por evento: sem isto o arrastar começa e só é revertido no
         fim, o que parece uma falha em vez de uma regra. */
      editable: podeAlterarRegisto(appointment.estabelecimento, auth),
    }));
  };

  const formatCompromissos = (compromissos) => {
    return compromissos.map((compromisso) => ({
      id: compromisso._id,
      title: " " + compromisso.compromisso,
      start: new Date(compromisso.data_inicio_execucao),
      end: new Date(compromisso.data_fim_execucao),
      backgroundColor: "#F5F5F5",
      borderColor: "#616161",
      textColor: "#616161",
      extendedProps: {
        isCompromisso: true,
        agendadoPor: compromisso.agendadoPor?.name,
        estabelecimento: compromisso.estabelecimento || null,
      },
      editable: podeAlterarRegisto(compromisso.estabelecimento, auth),
    }));
  };

  const formatTratamentoIsolados = (trtIsol) => {
    return trtIsol.map((tratamentoIsolado) => ({
      id: tratamentoIsolado._id,
      title: ` ${tratamentoIsolado.cliente.nome.split(" ")[0]} ${
        tratamentoIsolado.cliente.nome.split(" ")[
          tratamentoIsolado.cliente.nome.split(" ").length - 1
        ]
      } - ${
        tratamentoIsolado.tratamento?.designacao
          ? tratamentoIsolado.tratamento.designacao
          : tratamentoIsolado.categoriaTratamento?.categoria
      }`,
      start: new Date(tratamentoIsolado.data_inicio_execucao),
      end: new Date(tratamentoIsolado.data_fim_execucao),
      backgroundColor: tratamentoIsolado.atendido
        ? "#F2FAF5"
        : tratamentoIsolado.faltou
          ? "#FFF3F6"
          : "#D7CCC8",
      borderColor: tratamentoIsolado.atendido
        ? "#39B93A"
        : tratamentoIsolado.faltou
          ? "#D96C60"
          : "#5D4037",
      textColor: tratamentoIsolado.atendido
        ? "#39B93A"
        : tratamentoIsolado.faltou
          ? "#D96C60"
          : "#5D4037",
      extendedProps: {
        isTratamentoIsolado: true,
        comEntrada: tratamentoIsolado.entrada ? true : false,
        clientId: tratamentoIsolado.cliente._id,
        procedureId:
          tratamentoIsolado.tratamento?._id ||
          tratamentoIsolado.categoriaTratamento?._id,
        isAttended: tratamentoIsolado.atendido,
        isMissed: tratamentoIsolado.faltou,
        agendadoPor: tratamentoIsolado.agendadoPor?.name,
        observacoesAgendamento: tratamentoIsolado.observacoesAgendamento,
        listaEsperaId: tratamentoIsolado?.listaEspera || null,
        /* Só o booleano. O servidor já o calcula (`confirmado`) e manda
           exactamente isto — nem data, nem nome de quem confirmou. Esses
           ficam na lista da secretária, onde há espaço para os ler. */
        confirmado: !!tratamentoIsolado.confirmado,
        estabelecimento: tratamentoIsolado.estabelecimento || null,
        codigoUnidade: verTodasUnidades
          ? (tratamentoIsolado.estabelecimento?.codigo ?? null)
          : null,
        nomeUnidade: tratamentoIsolado.estabelecimento?.nome ?? null,
      },
      editable: podeAlterarRegisto(tratamentoIsolado.estabelecimento, auth),
    }));
  };

  const formatAgendamentosProvisorio = (agendamentosProv) => {
    return agendamentosProv.map((agProv) => ({
      id: agProv._id,
      start: new Date(agProv.data_inicio_execucao),
      end: new Date(agProv.data_fim_execucao),
      title: ` ${agProv.cliente.nome.split(" ")[0]} ${
        agProv.cliente.nome.split(" ")[
          agProv.cliente.nome.split(" ").length - 1
        ]
      } - Agendamento provisório`,

      backgroundColor: "#FFF3E0",
      borderColor: "#FF8F00",
      textColor: "#663C00",
      extendedProps: {
        isAgendamentoProvisorio: true,
        clientId: agProv.cliente._id,
        agendadoPor: agProv.agendadoPor?.name,
        observacoesAgendamento: agProv.observacoesAgendamento,
        estabelecimento: agProv.estabelecimento || null,
      },
      editable: podeAlterarRegisto(agProv.estabelecimento, auth),
    }));
  };

  const formatExcecoes = (disponibilidade, horarioAtend) => {
    if (!disponibilidade?.excecoes) return [];

    const excecaoEvents = [];

    disponibilidade.excecoes.forEach((excecao, index) => {
      const data = moment(moment.utc(excecao.data).format("YYYY-MM-DD"));

      if (excecao.bloqueado) {
        // Dia totalmente bloqueado - criar evento que ocupa o dia todo
        excecaoEvents.push({
          id: `excecao-bloqueio-${index}`,
          title: `🚫 Bloqueado${excecao.motivo ? " - " + excecao.motivo : ""}`,
          start: data
            .clone()
            .set({
              hour: parseInt(horarioAtend.start.split(":")[0]),
              minute: 0,
            })
            .toDate(),
          end: data
            .clone()
            .set({
              hour: parseInt(horarioAtend.end.split(":")[0]),
              minute: 0,
            })
            .toDate(),
          backgroundColor: "#D32F2F",
          borderColor: "#B71C1C",
          textColor: "#FFFFFF",
          extendedProps: {
            isExcecao: true,
            bloqueado: true,
            isCompromisso: false,
          },
        });
      } else if (excecao.periodos && excecao.periodos.length > 0) {
        // Dia com horário alterado - criar eventos apenas nos períodos FORA do horário especial
        // Primeiro, identificar os gaps (períodos indisponíveis)
        const periodosIndisponiveis = identificarPeriodosIndisponiveis(
          excecao.periodos,
          data,
          horarioAtend,
        );

        periodosIndisponiveis.forEach((periodo, pIndex) => {
          excecaoEvents.push({
            id: `excecao-indisponivel-${index}-${pIndex}`,
            title: `⚠️ Horário Especial${
              excecao.motivo ? " - " + excecao.motivo : ""
            }`,
            start: periodo.start.toDate(),
            end: periodo.end.toDate(),
            backgroundColor: "#F57C00",
            borderColor: "#E65100",
            textColor: "#FFFFFF",
            extendedProps: {
              isExcecao: true,
              bloqueado: false,
              isCompromisso: false,
              motivo: excecao.motivo,
            },
          });
        });
      }
    });

    return excecaoEvents;
  };

  const getMotivoBloqueio = (date) => {
    const dayOfWeek = date.getDay();

    // Verificar se o dia está nos dias disponíveis
    if (
      disponibilidadeMedico?.diasDisponiveis &&
      !disponibilidadeMedico.diasDisponiveis.includes(dayOfWeek)
    ) {
      return "Dia não disponível para atendimento";
    }

    const timeInMinutes = date.getHours() * 60 + date.getMinutes();
    const dataCheck = moment(date).startOf("day");

    // Verificar exceções primeiro
    if (disponibilidadeMedico?.excecoes) {
      const excecao = disponibilidadeMedico.excecoes.find((exc) =>
        moment(moment.utc(exc.data).format("YYYY-MM-DD")).isSame(
          dataCheck,
          "day",
        ),
      );

      if (excecao) {
        if (excecao.bloqueado) {
          return excecao.motivo || "Dia bloqueado";
        }
        // Verificar se está fora dos períodos da exceção
        const dentroDeAlgumPeriodo = excecao.periodos?.some((periodo) => {
          const startMin = timeToMinutes(periodo.start);
          const endMin = timeToMinutes(periodo.end);
          return timeInMinutes >= startMin && timeInMinutes < endMin;
        });
        if (!dentroDeAlgumPeriodo) {
          return excecao.motivo || "Horário especial";
        }
      }
    }

    // Verificar períodos especiais
    if (disponibilidadeMedico?.periodosEspeciais) {
      const periodoEspecial = disponibilidadeMedico.periodosEspeciais.find(
        (periodo) => {
          const inicio = moment(
            moment.utc(periodo.dataInicio).format("YYYY-MM-DD"),
          );
          const fim = moment(moment.utc(periodo.dataFim).format("YYYY-MM-DD"));
          return (
            dataCheck.isSameOrAfter(inicio) && dataCheck.isSameOrBefore(fim)
          );
        },
      );

      if (periodoEspecial) {
        const periodosHoje =
          periodoEspecial.horarioPadrao?.[dayOfWeek.toString()];

        if (!periodosHoje || periodosHoje.length === 0) {
          return periodoEspecial.nome;
        }

        const dentroDeAlgumPeriodo = periodosHoje.some((periodo) => {
          const startMin = timeToMinutes(periodo.start);
          const endMin = timeToMinutes(periodo.end);
          return timeInMinutes >= startMin && timeInMinutes < endMin;
        });

        if (!dentroDeAlgumPeriodo) {
          return periodoEspecial.nome;
        }
      }
    }

    // Verificar horário padrão
    if (disponibilidadeMedico?.horarioPadrao) {
      const periodosHoje =
        disponibilidadeMedico.horarioPadrao[dayOfWeek.toString()];
      if (!periodosHoje || periodosHoje.length === 0) {
        return "Fora do horário de trabalho";
      }

      const dentroDeAlgumPeriodo = periodosHoje.some((periodo) => {
        const startMin = timeToMinutes(periodo.start);
        const endMin = timeToMinutes(periodo.end);
        return timeInMinutes >= startMin && timeInMinutes < endMin;
      });

      if (!dentroDeAlgumPeriodo) {
        return "Fora do horário de atendimento";
      }
    }

    return null; // Está disponível
  };

  const identificarPeriodosIndisponiveis = (
    periodosDisponiveis,
    data,
    horarioAtendimento,
  ) => {
    const indisponiveis = [];

    // Converter períodos disponíveis para momentos
    const periodos = periodosDisponiveis
      .map((p) => ({
        start: moment(data).set({
          hour: moment(p.start, "HH:mm:ss").hour(),
          minute: moment(p.start, "HH:mm:ss").minute(),
          second: 0,
        }),
        end: moment(data).set({
          hour: moment(p.end, "HH:mm:ss").hour(),
          minute: moment(p.end, "HH:mm:ss").minute(),
          second: 0,
        }),
      }))
      .sort((a, b) => a.start.diff(b.start));

    const inicioJornada = moment(data).set({
      hour: parseInt(horarioAtendimento.start.split(":")[0]),
      minute: parseInt(horarioAtendimento.start.split(":")[1]),
      second: 0,
    });

    const fimJornada = moment(data).set({
      hour: parseInt(horarioAtendimento.end.split(":")[0]),
      minute: parseInt(horarioAtendimento.end.split(":")[1]),
      second: 0,
    });

    // Se não começa no início da jornada
    if (periodos[0].start.isAfter(inicioJornada)) {
      indisponiveis.push({
        start: inicioJornada.clone(),
        end: periodos[0].start.clone(),
      });
    }

    // Gaps entre períodos
    for (let i = 0; i < periodos.length - 1; i++) {
      if (periodos[i].end.isBefore(periodos[i + 1].start)) {
        indisponiveis.push({
          start: periodos[i].end.clone(),
          end: periodos[i + 1].start.clone(),
        });
      }
    }

    // Se não termina no fim da jornada
    if (periodos[periodos.length - 1].end.isBefore(fimJornada)) {
      indisponiveis.push({
        start: periodos[periodos.length - 1].end.clone(),
        end: fimJornada.clone(),
      });
    }

    return indisponiveis;
  };

  const formatTransitionAppointments = (appointments) => {
    return appointments.map((appointment) => ({
      id: appointment._id,
      title: ` ${appointment.cliente.nome.split(" ")[0]} ${
        appointment.cliente.nome.split(" ")[
          appointment.cliente.nome.split(" ").length - 1
        ]
      } - ${appointment.categoriaTratamento.categoria}`,
      start: new Date(appointment.data_inicio_execucao),
      end: new Date(appointment.data_fim_execucao),
      backgroundColor: appointment.atendido
        ? "#F2FAF5"
        : appointment.faltou
          ? "#FFF3F6"
          : "#ebe5f5",
      borderColor: appointment.atendido
        ? "#39B93A"
        : appointment.faltou
          ? "#D96C60"
          : "#512DA8",
      textColor: appointment.atendido
        ? "#39B93A"
        : appointment.faltou
          ? "#D96C60"
          : "#512DA8",
      extendedProps: {
        clientId: appointment.cliente._id,
        procedureId: appointment.categoriaTratamento._id,
        inTransition: true,
        isAttended: appointment.atendido,
        isMissed: appointment.faltou,
        agendadoPor: appointment.agendadoPor?.name,
        observacoesAgendamento: appointment.observacoesAgendamento,
      },
    }));
  };

  /* Marcação de outra unidade: só leitura.
   *
   * Editar, arrastar ou eliminar daqui mexeria numa marcação que pertence ao
   * outro balcão — e a execução usaria o catálogo de tratamentos desta unidade
   * sobre algo que nasceu na outra. Vê-se, não se mexe.
   *
   * Espelha a `podeAlterarRegisto` do servidor, com as mesmas tolerâncias:
   * sessão sem unidade, ou marcação sem unidade, deixam passar. */
  const daMinhaUnidade = (event) =>
    podeAlterarRegisto(event.extendedProps?.estabelecimento, auth);

  const isEventEditable = (event) => {
    return (
      daMinhaUnidade(event) &&
      !(
        event.extendedProps.inTransition ||
        event.extendedProps.isAttended ||
        event.extendedProps.isMissed ||
        event.extendedProps.isAgendamentoProvisorio
      )
    );
  };

  const canAlterarData = (event) => {
    return (
      daMinhaUnidade(event) &&
      !(event.extendedProps.isAttended || event.extendedProps.isMissed)
    );
  };

  const handleEventDrop = async (dropInfo) => {
    const { event } = dropInfo;

    if (!canAlterarData(event)) {
      // Sem explicação, a marcação salta de volta e parece uma falha.
      if (!daMinhaUnidade(event)) {
        toast.error(
          motivoBloqueioUnidade(event.extendedProps?.estabelecimento),
        );
      }
      dropInfo.revert();
      return;
    }

    const endCheck = new Date(event.end.getTime() - 60000);
    if (
      !isDateTimeAvailable(
        event.start,
        disponibilidadeMedico,
        horarioAtendimento,
      ) ||
      !isDateTimeAvailable(endCheck, disponibilidadeMedico, horarioAtendimento)
    ) {
      toast.error(
        "Não é possível mover agendamento para fora do horário de atendimento",
      );
      dropInfo.revert();
      return;
    }

    let model = "Agenda";

    if (event.extendedProps.isEvaluation) {
      model = "Agenda";
    } else if (event.extendedProps.isCompromisso) {
      model = "Compromisso";
    } else if (event.extendedProps.isTratamentoIsolado) {
      model = "TratamentoIsolado";
    } else {
      model = "Agenda";
    }

    /* ─── A MARCAÇÃO JÁ ESTAVA CONFIRMADA ────────────────────────────────────
     *
     * O cliente confirmou uma data que está a mudar. Pergunta-se antes de
     * gravar — e a resposta decide se o ✓ sobrevive. Ver o diálogo para as
     * duas leituras opostas do mesmo gesto. */
    if (event.extendedProps?.confirmado) {
      setConfirmacaoEmRisco({
        modo: "mover",
        nomeCliente: event.title,
        prosseguir: (manterConfirmacao) =>
          gravarReagendamento(event, model, dropInfo, manterConfirmacao),
        cancelar: () => dropInfo.revert(),
      });
      return;
    }

    await gravarReagendamento(event, model, dropInfo, false);
  };

  /* A gravação do arrastar, separada para o diálogo da confirmação a poder
     chamar depois de a pessoa responder. */
  const gravarReagendamento = async (
    event,
    model,
    dropInfo,
    manterConfirmacao,
  ) => {
    try {
      const formData = new FormData();
      formData.append("model", model);
      formData.append("data_inicio_execucao", event.start);
      formData.append("data_fim_execucao", event.end);
      formData.append("utilizador", auth.userId);
      formData.append("nomeQuemAgendou", auth.nome);
      /* O servidor só mantém o ✓ com `true` explícito — ver
         `confirmacaoSobreviveAMudancaDeData`. */
      formData.append("manterConfirmacao", manterConfirmacao ? "true" : "false");

      startLoading();

      if (event.extendedProps.isAgendamentoProvisorio) {
        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/agendamentosprovisorio/reagendar/${event.id}`,
          "PATCH",
          formData,
          { Authorization: "Bearer " + auth.token },
        );
      } else {
        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/agenda/reagendar/${event.id}`,
          "PATCH",
          formData,
          { Authorization: "Bearer " + auth.token },
        );
      }
      stopLoading();

      // Update local state
      setEvents((prevEvents) =>
        prevEvents.map((e) =>
          e.id === event.id
            ? {
                ...e,
                extendedProps: {
                  ...e.extendedProps,
                  agendadoPor: auth.nome,
                  /* Sem isto o ✓ ficava no ecrã depois de o servidor o ter
                     apagado, e só desaparecia ao recarregar a página — a
                     agenda a dizer que o doente confirmou uma hora que já não
                     é a dele. */
                  confirmado: manterConfirmacao
                    ? e.extendedProps.confirmado
                    : false,
                },
                start: event.start,
                end: event.end,
              }
            : e,
        ),
      );
    } catch (err) {
      stopLoading();
      console.error("err", err);
      dropInfo.revert();
    }
  };

  const handleDateClick = (arg) => {
    if (clickRef.current && arg.date.getTime() === clickRef.current.getTime()) {
      const motivoBloqueio = getMotivoBloqueio(arg.date);

      if (motivoBloqueio) {
        toast.error(`Não é possível agendar: ${motivoBloqueio}`);
        clickRef.current = null;
        return;
      }

      const dataFimCheck = moment(arg.date)
        .add(duracaoConsulta, "minutes")
        .subtract(1, "minute")
        .toDate();
      const motivoBloqueioFim = getMotivoBloqueio(dataFimCheck);
      if (motivoBloqueioFim) {
        toast.error(
          `Não é possível agendar neste horário. O período ultrapassa o disponível (${motivoBloqueioFim})`,
        );
        clickRef.current = null;
        return;
      }

      setSelectedDate(arg.date);
      setIsFormOpen(true);
      setSelectedEvent(null);
      clickRef.current = null;
    } else {
      // First click — apenas guarda a referência, sem validação
      clickRef.current = arg.date;
      setTimeout(() => {
        clickRef.current = null;
      }, 300);
    }
  };

  const handleEventClick = (info) => {
    if (info.event.display === "background") {
      return;
    }
    if (
      clickRef.current &&
      info.event.start.getTime() === clickRef.current.getTime()
    ) {
      // Double click detected on an event
      if (isEventEditable(info.event)) {
        if (info.event.extendedProps.listaEsperaId) {
          toast.error(
            "Agendamentos da lista de espera não podem ser editados. Elimine e crie um novo.",
          );
          return;
        }
        setSelectedDate(info.event.start);
        setSelectedEvent(info.event);
        setIsFormOpen(true);
      }
      clickRef.current = null;
    } else {
      // First click - show tooltip
      const rect = info.el.getBoundingClientRect();
      setTooltipPosition({
        x: rect.left + window.scrollX,
        y: rect.bottom + window.scrollY,
      });
      setTooltipEvent(info.event);

      // Set up for potential double click
      clickRef.current = info.event.start;
      setTimeout(() => {
        clickRef.current = null;
      }, 300);
    }
  };

  const handleCloseTooltip = () => {
    setTooltipEvent(null);
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
    setSelectedDate(null);
  };

  const handleDeleteEvent = async (
    event,
    skipListaEsperaReload = false,
    jaAvisado = false,
  ) => {
    /* ─── A MARCAÇÃO ESTAVA CONFIRMADA ───────────────────────────────────────
     *
     * Aqui não há ✓ para manter — a marcação vai desaparecer. O aviso existe
     * porque alguém disse que vinha e vai aparecer à porta: a secretária fica
     * a saber que lhe deve um telefonema. Sem isto, eliminava-se em silêncio e
     * o doente só descobria ao chegar.
     *
     * O `jaAvisado` é um parâmetro PRÓPRIO, e não o `skipListaEsperaReload`:
     * esse existe para outra coisa, e usá-lo aqui fazia uma chamada legítima
     * com `skip` saltar o aviso em silêncio. */
    if (event.extendedProps?.confirmado && !jaAvisado) {
      setConfirmacaoEmRisco({
        modo: "eliminar",
        nomeCliente: event.title,
        prosseguir: () => eliminarEvento(event, skipListaEsperaReload),
        cancelar: () => {},
      });
      return;
    }

    await eliminarEvento(event, skipListaEsperaReload);
  };

  /* A eliminação, separada para o aviso da confirmação a poder chamar depois
     de a pessoa responder. */
  const eliminarEvento = async (event, skipListaEsperaReload = false) => {
    if (event.extendedProps.isTratamentoIsolado) {
      try {
        startLoading();
        const tratamentoIsoladoEncontrada = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoIsolados/${event.id}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token },
        );
        if (
          tratamentoIsoladoEncontrada.tratamentoIsolado?.entrada
            ?.entradaRecebida
        ) {
          toast.error(
            "O tratamento Isolado não pode ser eliminado pois já foi recebido!",
          );
          return;
        }

        const formData = new FormData();
        formData.append("utilizador", auth.userId);

        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoIsolados/eliminar/${event.id}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        );

        toast.success(
          `Eliminação do tratamento Isolado ${
            tratamentoIsoladoEncontrada.tratamentoIsolado.entrada
              ? "e da entrada efetuados"
              : "efetuado"
          } com sucesso!`,
        );

        setEvents((prevEvents) => prevEvents.filter((e) => e.id !== event.id));

        // Reverter lista de espera se aplicável
        if (event.extendedProps.listaEsperaId && !skipListaEsperaReload) {
          setListaEsperaContagem((prev) =>
            prev
              ? {
                  ...prev,
                  total: prev.total + 1,
                }
              : null,
          );

          const formDataListaEspera = new FormData();
          formDataListaEspera.append("clinicaId", clinica.clinica._id);

          // Recarregar lista de espera para ter o item de volta
          try {
            const listaEsperaResponse = await sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/listaespera/medico/${medicoId}`,
              "POST",
              formDataListaEspera,
              { Authorization: "Bearer " + auth.token },
            );
            setListaEsperaContagem(listaEsperaResponse.contagem);
            setListaEspera(listaEsperaResponse.listaEspera);
          } catch (err) {
            console.error("Erro ao recarregar lista de espera:", err);
          }
        }
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
        handleCloseTooltip();
        handleModalCancel();
      }
    } else if (event.extendedProps.isAgendamentoProvisorio) {
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/agendamentosprovisorio/${event.id}`,
        "DELETE",
        null,
        { Authorization: "Bearer " + auth.token },
      );

      setEvents((prevEvents) => prevEvents.filter((e) => e.id !== event.id));
      handleCloseTooltip();
    } else {
      try {
        startLoading();
        let path = "agenda";

        if (event.extendedProps.inTransition) {
          path = "agendamentosemtransicao";
        } else if (event.extendedProps.isCompromisso) {
          path = "compromissos";
        }

        const formData = new FormData();
        formData.append("utilizador", auth.userId);
        if (!event.extendedProps.isCompromisso) {
          formData.append("nomeCliente", event.title.split(" - ")[0]);
          formData.append("procedimento", event.title.split(" - ")[1]);
        } else {
          formData.append("compromisso", event.title.trim());
        }
        formData.append(
          "dataInicial",
          moment(event.start).format("DD/MM/YYYY HH:mm"),
        );
        formData.append(
          "dataFinal",
          moment(event.end).format("DD/MM/YYYY HH:mm"),
        );

        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/${path}/eliminarmarcacao/${event.id}`,
          "PATCH",
          formData,
          { Authorization: "Bearer " + auth.token },
        );

        setEvents((prevEvents) => prevEvents.filter((e) => e.id !== event.id));

        // Reverter lista de espera se aplicável
        if (event.extendedProps.listaEsperaId) {
          setListaEsperaContagem((prev) =>
            prev
              ? {
                  ...prev,
                  total: prev.total + 1,
                }
              : null,
          );

          const formDataListaEspera = new FormData();
          formDataListaEspera.append("clinicaId", clinica.clinica._id);
          // Recarregar lista de espera para ter o item de volta
          try {
            const listaEsperaResponse = await sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/listaespera/medico/${medicoId}`,
              "POST",
              formDataListaEspera,
              { Authorization: "Bearer " + auth.token },
            );
            setListaEsperaContagem(listaEsperaResponse.contagem);
            setListaEspera(listaEsperaResponse.listaEspera);
          } catch (err) {
            console.error("Erro ao recarregar lista de espera:", err);
          }
        }

        handleCloseTooltip();
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    }
    handleModalCancel();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        handleCloseTooltip();
      }
    };

    if (tooltipEvent) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [tooltipEvent]);

  const updateEvents = (
    event,
    eventId,
    clienteAdicionado,
    houveAlteracaoTipoAgendamento,
    agendamentoAntigo,
  ) => {
    // Update funcional: no agendamento múltiplo esta função é chamada várias
    // vezes seguidas (uma por sessão). Ler o `events` capturado faria cada
    // chamada partir da mesma base e só a última sobreviveria (ficava só 1
    // evento no ecrã até dar refresh).
    setEvents((prev) => {
      let newEvents = [...prev];

      if (!eventId) {
        newEvents = [
          ...newEvents,
          { ...event, start: new Date(event.start), end: new Date(event.end) },
        ];
      } else {
        newEvents = newEvents.map((ev) =>
          ev.id === eventId
            ? {
                id: ev.id,
                ...event,
                start: new Date(event.start),
                end: new Date(event.end),
                /* ─── O ✓ SOBREVIVE À EDIÇÃO ──────────────────────────────
                 *
                 * Isto substitui o evento INTEIRO pelo que o formulário
                 * devolve, e esse não traz o `confirmado`. Resultado: mudar
                 * só as observações fazia o ✓ desaparecer do ecrã — e voltar
                 * ao recarregar a página, porque na base nunca saiu.
                 *
                 * Mantém-se o valor anterior, a não ser que o formulário
                 * traga um explicitamente. Quem muda a confirmação é o botão
                 * da secretária e o diálogo do arrastar, não esta função. */
                extendedProps: {
                  ...event.extendedProps,
                  confirmado:
                    event.extendedProps?.confirmado ??
                    ev.extendedProps?.confirmado ??
                    false,
                },
              }
            : ev,
        );
      }

      if (houveAlteracaoTipoAgendamento) {
        newEvents = newEvents.filter((e) => e.id !== agendamentoAntigo);
      }

      return newEvents;
    });

    if (clienteAdicionado) {
      setClients((prev) => [
        ...prev,
        { id: clienteAdicionado._id, label: clienteAdicionado.nome },
      ]);
    }
    handleCloseForm();
  };

  const handleApagarAgendamento = async (event) => {
    if (event.extendedProps.listaEsperaId) {
      setListaEsperaDeleteDialog({
        show: true,
        event: event,
      });
    } else {
      setModalProps({
        show: true,
        icon: "info",
        title: `Apagar Agendamento!`,
        message: `Tem a certeza que pretende apagar o Agendamento?`,
        form: true,
        onCancel: handleModalCancel,
        onConfirm: handleDeleteEvent.bind(null, event),
      });
    }
  };

  const handleModalCancel = () => {
    setModalProps((currentModalProps) => {
      return { ...currentModalProps, show: false };
    });
  };

  const handleConfirmMove = async (moveData, event) => {
    startLoading();
    const model = event.extendedProps.inTransition
      ? "AgendamentosEmTransicao"
      : event.extendedProps.isCompromisso
        ? "Compromisso"
        : event.extendedProps.isTratamentoIsolado
          ? "TratamentoIsolado"
          : "Agenda";
    try {
      // Mapear model para endpoint
      const endpointMap = {
        Agenda: `${process.env.REACT_APP_BACKEND_LINK}/api/agenda/move`,
        TratamentoIsolado: `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoisolados/move`,
      };

      const endpoint = endpointMap[model];

      if (!endpoint) {
        toast.error(`Movimentação não suportada para: ${model}`);
        return;
      }

      const response = await sendRequest(
        endpoint,
        "POST",
        JSON.stringify({
          appointmentId: event.id,
          targetDoctorId: moveData.targetDoctorId,
          newStartDate: moveData.newStartDate,
          newEndDate: moveData.newEndDate,
          user: auth.userId,
          notifyDoctor: moveData.notifyDoctor,
          forceOverlap: false,
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
        { skipErrorHandler: true },
      );

      if (response.success) {
        toast.success("Agendamento movido com sucesso!");
        setEvents((prevEvents) => prevEvents.filter((e) => e.id !== event.id));
        setMoveDialogOpen(false);
        setSelectedEventToMove(null);
      }
    } catch (err) {
      if (err.response?.status === 409) {
        // Conflito detectado
        setConflictData({
          ...err.response.data,
          movingAppointment: {
            ...err.response.data.movingAppointment,
            id: event.id,
            model: model,
          },
          originalMoveData: moveData,
          originalEvent: event,
        });
        setConflictDialogOpen(true);
      } else {
        toast.error(err.message || "Erro ao mover agendamento");
        console.error(err);
      }
    } finally {
      stopLoading();
    }
  };

  const handleConflictResolution = async (resolution) => {
    startLoading();
    try {
      const event = conflictData.originalEvent;
      const moveData = conflictData.originalMoveData;

      if (resolution.action === "overlap") {
        // Encaixar - fazer movimentação com forceOverlap
        const model = event.extendedProps.isTratamentoIsolado
          ? "TratamentoIsolado"
          : "Agenda";

        const endpointMap = {
          Agenda: `${process.env.REACT_APP_BACKEND_LINK}/api/agenda/move`,
          TratamentoIsolado: `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoisolados/move`,
        };

        const response = await sendRequest(
          endpointMap[model],
          "POST",
          JSON.stringify({
            appointmentId: event.id,
            targetDoctorId: moveData.targetDoctorId,
            newStartDate: moveData.newStartDate,
            newEndDate: moveData.newEndDate,
            user: auth.userId,
            notifyDoctor: resolution.notifyDoctor,
            forceOverlap: true,
          }),
          {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          { skipErrorHandler: true },
        );

        if (response.success) {
          toast.success("Agendamento encaixado com sucesso!");
          setEvents((prevEvents) =>
            prevEvents.filter((e) => e.id !== event.id),
          );
        }
      } else if (resolution.action === "swap") {
        // Trocar agendamentos
        const model1 = conflictData.movingAppointment.model;
        const model2 = conflictData.conflictingAppointments[0].model;

        let endpoint, payload;

        if (model1 === model2) {
          // Swap intra-collection
          const swapEndpointMap = {
            Agenda: `${process.env.REACT_APP_BACKEND_LINK}/api/agenda/swap`,
            TratamentoIsolado: `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoisolados/swap`,
          };

          endpoint = swapEndpointMap[model1];
          payload = {
            appointmentId1: conflictData.movingAppointment.id,
            appointmentId2: conflictData.conflictingAppointments[0].id,
            user: auth.userId,
            secretariaNome: auth.name,
          };
        } else {
          // Swap cross-model
          endpoint = `${process.env.REACT_APP_BACKEND_LINK}/api/agenda/swapCrossModel`;
          payload = {
            appointment1: {
              id: conflictData.movingAppointment.id,
              model: model1,
            },
            appointment2: {
              id: conflictData.conflictingAppointments[0].id,
              model: model2,
            },
            user: auth.userId,
            secretariaNome: auth.name,
          };
        }

        const response = await sendRequest(
          endpoint,
          "POST",
          JSON.stringify(payload),
          {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
        );

        if (response.success) {
          toast.success("Agendamentos trocados com sucesso!");

          const conflictingAppointment =
            conflictData.conflictingAppointments[0];

          setEvents((prevEvents) => {
            let updatedEvents = prevEvents.filter((e) => e.id !== event.id);

            const conflictEventExists = updatedEvents.some(
              (e) => e.id === conflictingAppointment.id,
            );

            if (!conflictEventExists) {
              const newEvent = {
                id: conflictingAppointment.id,
                title: ` ${getFirstAndLastName(
                  conflictingAppointment.cliente,
                )} - ${conflictingAppointment.procedimento}`,
                start: new Date(conflictingAppointment.start),
                end: new Date(conflictingAppointment.end),
                backgroundColor: event.backgroundColor,
                borderColor: event.borderColor,
                textColor: event.textColor,
                extendedProps: {
                  isTratamentoIsolado:
                    conflictingAppointment.model === "TratamentoIsolado",
                  isAgendaTratamento:
                    conflictingAppointment.model === "AgendaTratamento",
                  comEntrada: conflictingAppointment.comEntrada || false,
                  isAttended: conflictingAppointment.atendido || false,
                  isMissed: conflictingAppointment.faltou || false,
                  agendadoPor: auth.nome,
                  isEvaluation: false,
                  inTransition: false,
                  isCompromisso: false,
                },
              };

              updatedEvents = [...updatedEvents, newEvent];
            }

            return updatedEvents;
          });
        }
      }

      // Limpar estados
      setConflictDialogOpen(false);
      setConflictData(null);
      setMoveDialogOpen(false);
      setSelectedEventToMove(null);
    } catch (err) {
      toast.error("Erro ao processar conflito!");
      console.error(err);
    } finally {
      stopLoading();
    }
  };

  // Função para converter disponibilidade em businessHours do FullCalendar
  const getBusinessHours = () => {
    if (!disponibilidadeMedico?.horarioPadrao) {
      // Fallback para o horário simples atual
      return {
        daysOfWeek: [1, 2, 3, 4, 5],
        startTime: horarioAtendimento.start,
        endTime: horarioAtendimento.end,
      };
    }

    const businessHours = [];
    const horarioPadraoObj = disponibilidadeMedico.horarioPadrao;

    // Iterar pelos dias (0-6)
    Object.keys(horarioPadraoObj).forEach((dia) => {
      const periodos = horarioPadraoObj[dia];

      if (periodos && Array.isArray(periodos) && periodos.length > 0) {
        periodos.forEach((periodo) => {
          businessHours.push({
            daysOfWeek: [parseInt(dia)],
            startTime: periodo.start,
            endTime: periodo.end,
          });
        });
      }
    });

    // MUDANÇA: Não retornar fallback se não houver períodos configurados
    // Isso garante que apenas os dias com períodos sejam considerados "business hours"
    return businessHours.length > 0 ? businessHours : [];
  };

  const timeToMinutes = (timeStr) => {
    const parts = timeStr.split(":");
    return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
  };

  const formatPeriodosEspeciaisBackground = (disponibilidade, horarioAtend) => {
    if (!disponibilidade?.periodosEspeciais) return [];

    const events = [];

    disponibilidade.periodosEspeciais.forEach((periodo, pIndex) => {
      const inicio = moment(
        moment.utc(periodo.dataInicio).format("YYYY-MM-DD"),
      );
      const fim = moment(moment.utc(periodo.dataFim).format("YYYY-MM-DD"));
      const current = inicio.clone();

      while (current.isSameOrBefore(fim, "day")) {
        const dayOfWeek = current.day().toString();

        // Verificar se este dia já tem uma exceção (exceções têm prioridade)
        const temExcecao = disponibilidade.excecoes?.some((exc) =>
          moment(moment.utc(exc.data).format("YYYY-MM-DD")).isSame(
            current,
            "day",
          ),
        );

        if (!temExcecao) {
          const periodosEspeciaisDia = periodo.horarioPadrao?.[dayOfWeek] || [];
          const horarioPadraoDia =
            disponibilidade.horarioPadrao?.[dayOfWeek] || [];

          // Só criar blocos se houver diferença
          const especiaisStr = JSON.stringify(
            periodosEspeciaisDia.map((p) => ({ start: p.start, end: p.end })),
          );
          const padraoStr = JSON.stringify(
            horarioPadraoDia.map((p) => ({ start: p.start, end: p.end })),
          );

          if (especiaisStr !== padraoStr) {
            if (periodosEspeciaisDia.length === 0) {
              // Dia completamente indisponível
              events.push({
                id: `pe-bg-${pIndex}-${current.format("YYYY-MM-DD")}`,
                start: current
                  .clone()
                  .set({
                    hour: parseInt(horarioAtend.start.split(":")[0]),
                    minute: parseInt(horarioAtend.start.split(":")[1] || 0),
                  })
                  .toDate(),
                end: current
                  .clone()
                  .set({
                    hour: parseInt(horarioAtend.end.split(":")[0]),
                    minute: parseInt(horarioAtend.end.split(":")[1] || 0),
                  })
                  .toDate(),
                display: "background",
                backgroundColor: "#e0e0e0",
              });
            } else {
              // Mostrar os gaps como indisponíveis
              const indisponiveis = identificarPeriodosIndisponiveis(
                periodosEspeciaisDia,
                current,
                horarioAtend,
              );

              indisponiveis.forEach((ind, iIndex) => {
                events.push({
                  id: `pe-bg-${pIndex}-${current.format(
                    "YYYY-MM-DD",
                  )}-${iIndex}`,
                  start: ind.start.toDate(),
                  end: ind.end.toDate(),
                  display: "background",
                  backgroundColor: "#e0e0e0",
                });
              });
            }
          }
        }

        current.add(1, "day");
      }
    });

    return events;
  };

  const getHiddenDays = () => {
    // Se tem diasDisponiveis definido, usa ele
    if (disponibilidadeMedico?.diasDisponiveis) {
      const todosDias = [0, 1, 2, 3, 4, 5, 6];
      return todosDias.filter(
        (dia) => !disponibilidadeMedico.diasDisponiveis.includes(dia),
      );
    }

    // Fallback: calcula com base no horarioPadrao
    if (disponibilidadeMedico?.horarioPadrao) {
      const hiddenDays = [];
      for (let dia = 0; dia <= 6; dia++) {
        const periodos = disponibilidadeMedico.horarioPadrao[dia.toString()];
        if (!periodos || periodos.length === 0) {
          hiddenDays.push(dia);
        }
      }
      return hiddenDays;
    }

    return [0, 6]; // Fallback padrão: esconde sábado e domingo
  };

  const handleDeleteAndReturnToList = async () => {
    const event = listaEsperaDeleteDialog.event;
    setListaEsperaDeleteDialog({ show: false, event: null });
    await handleDeleteEvent(event);
  };

  const handleDeleteAndRemoveFromList = async () => {
    const event = listaEsperaDeleteDialog.event;
    setListaEsperaDeleteDialog({ show: false, event: null });

    // Eliminar agendamento sem recarregar lista de espera
    await handleDeleteEvent(event, true);

    // Marcar como desistiu na lista de espera
    try {
      const formData = new FormData();
      formData.append("utilizador", auth.userId);
      formData.append("status", "desistiu");

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/listaespera/updateStatusListaEspera/${event.extendedProps.listaEsperaId}`,
        "PATCH",
        formData,
        { Authorization: "Bearer " + auth.token },
      );

      // Remover do frontend
      setListaEspera((prev) =>
        prev.filter((i) => i._id !== event.extendedProps.listaEsperaId),
      );
      setListaEsperaContagem((prev) =>
        prev
          ? {
              ...prev,
              total: prev.total - 1,
            }
          : null,
      );
    } catch (err) {
      console.error("Erro ao remover da lista de espera:", err);
    }
  };

  return (
    <div className="datatable-container" style={{ backgroundColor: "white" }}>
      <ModalInfo {...modalProps} />

      {/* Mexer numa marcação confirmada pára aqui. Ver o diálogo: mover tem
          duas leituras opostas e só quem move sabe qual é. */}
      <DialogoConfirmacaoAgendamento
        aberto={!!confirmacaoEmRisco}
        modo={confirmacaoEmRisco?.modo}
        nomeCliente={confirmacaoEmRisco?.nomeCliente}
        aoManter={() => {
          const acao = confirmacaoEmRisco;
          setConfirmacaoEmRisco(null);
          acao?.prosseguir(true);
        }}
        aoRetirar={() => {
          const acao = confirmacaoEmRisco;
          setConfirmacaoEmRisco(null);
          acao?.prosseguir(false);
        }}
        aoCancelar={() => {
          const acao = confirmacaoEmRisco;
          setConfirmacaoEmRisco(null);
          acao?.cancelar();
        }}
      />

      {listaEsperaDeleteDialog.show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              padding: "24px",
              maxWidth: "450px",
              width: "90%",
              boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            }}
          >
            <h3 style={{ margin: "0 0 8px 0" }}>Apagar Agendamento</h3>
            <p style={{ color: "#666", marginBottom: "20px" }}>
              Este agendamento foi criado a partir da lista de espera. O que
              deseja fazer?
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <button
                onClick={handleDeleteAndReturnToList}
                style={{
                  padding: "12px 16px",
                  backgroundColor: "#7B1FA2",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
              >
                ⏳ Apagar e retornar à lista de espera
              </button>
              <button
                onClick={handleDeleteAndRemoveFromList}
                style={{
                  padding: "12px 16px",
                  backgroundColor: "#D32F2F",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
              >
                🗑️ Apagar e remover da lista de espera
              </button>
              <button
                onClick={() =>
                  setListaEsperaDeleteDialog({ show: false, event: null })
                }
                style={{
                  padding: "12px 16px",
                  backgroundColor: "#f5f5f5",
                  color: "#333",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* De que unidade são as marcações. Fica por cima do calendário: quem
          olha para a agenda tem de saber de que balcão ela é antes de a ler. */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
          marginBottom: "4px",
        }}
      >
        <SeletorUnidadeDados valor={unidadeDados} onChange={setUnidadeDados} />
      </div>

      {showLoadOldButton && !loadOldAppointments && (
        <div
          style={{
            padding: "16px",
            backgroundColor: "#FFF3E0",
            borderRadius: "8px",
            marginBottom: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: "1px solid #FFB74D",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "20px" }}>📅</span>
            <span style={{ color: "#E65100", fontWeight: "500" }}>
              Você está visualizando datas antigas. Deseja carregar os
              agendamentos anteriores?
            </span>
          </div>
          <button
            onClick={handleLoadOldAppointments}
            style={{
              padding: "8px 16px",
              backgroundColor: "#FF9800",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "500",
              whiteSpace: "nowrap",
            }}
          >
            Carregar Agendamentos Antigos
          </button>
        </div>
      )}

      {listaEsperaContagem &&
        listaEsperaContagem.total > 0 &&
        listaEsperaPortalEl &&
        ReactDOM.createPortal(
          <div className="lista-espera-badge-container">
            <div className="lista-espera-badge">
              <span>⏳ Lista de Espera</span>
              <span className="badge-count">{listaEsperaContagem.total}</span>
              <div className="lista-espera-tooltip">
                <div className="tooltip-row urgente">
                  <span>Urgente</span>
                  <span>{listaEsperaContagem.urgente}</span>
                </div>
                <div className="tooltip-row normal">
                  <span>Normal</span>
                  <span>{listaEsperaContagem.normal}</span>
                </div>
                <div className="tooltip-row rotina">
                  <span>Rotina</span>
                  <span>{listaEsperaContagem.rotina}</span>
                </div>
              </div>
            </div>
          </div>,
          listaEsperaPortalEl,
        )}

      {events && (
        <FullCalendar
          ref={calendarRef}
          plugins={[timeGridPlugin, interactionPlugin]}
          // plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView="timeGridWeek"
          locale={ptLocale}
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "timeGridWeek,timeGridDay",
            // right: "dayGridMonth,timeGridWeek,timeGridDay",
          }}
          buttonText={{
            today: "Esta Semana",
            // month: "Mês",
            week: "Semana",
            day: "Dia",
          }}
          height="auto"
          slotDuration={`00:${duracaoConsulta}:00`}
          slotLabelInterval={`00:${duracaoConsulta}`}
          slotLabelFormat={{
            hour: "numeric",
            minute: "2-digit",
            omitZeroMinute: false,
            meridiem: "short",
          }}
          slotMinTime={horarioAtendimento.start}
          slotMaxTime={horarioAtendimento.end}
          allDaySlot={false}
          events={events}
          dateClick={handleDateClick}
          eventClick={handleEventClick}
          eventContent={renderEventContent}
          hiddenDays={getHiddenDays()}
          firstDay={1}
          editable={true}
          eventDrop={handleEventDrop}
          eventResize={handleEventDrop}
          eventStartEditable={isEventEditable}
          eventDurationEditable={isEventEditable}
          datesSet={handleDatesSet}
          businessHours={getBusinessHours()}
        />
      )}
      {tooltipEvent && (
        <div
          ref={tooltipRef}
          style={{
            position: "absolute",
            left: `${tooltipPosition.x}px`,
            top: `${tooltipPosition.y}px`,
          }}
        >
          <Tooltip
            event={tooltipEvent}
            handleApagarAgendamento={handleApagarAgendamento}
            onClose={handleCloseTooltip}
            auth={auth}
            handleMoverAgendamento={handleMoverAgendamento}
          />
        </div>
      )}
      <AppointmentForm
        isOpen={isFormOpen}
        onClose={handleCloseForm}
        date={selectedDate}
        event={selectedEvent}
        events={events}
        clients={clients}
        clientesProcedimento={clientesProcedimento}
        allTratamentos={allTratamentos}
        allCategoriasTratamento={allCategoriasTratamento}
        procedimentosPorMarcar={procedimentosPorMarcar}
        orcamentosPorMarcar={orcamentosPorMarcar}
        auth={auth}
        sendRequest={sendRequest}
        clinica={clinica}
        updateEvents={updateEvents}
        medicoId={medicoId}
        duracaoConsulta={duracaoConsulta}
        startLoading={startLoading}
        stopLoading={stopLoading}
        nomeMedico={nomeMedico}
        listaEspera={listaEspera}
        onAgendarDaLista={(id, prioridade) => {
          setListaEspera((prev) => prev.filter((i) => i._id !== id));
          setListaEsperaContagem((prev) => ({
            ...prev,
            total: prev.total - 1,
            [prioridade]: prev[prioridade] - 1,
          }));
        }}
        disponibilidadeMedico={disponibilidadeMedico}
        horarioAtendimento={horarioAtendimento}
      />

      {moveDialogOpen && auth.role === "Secretária(o)" && (
        <MoveAppointmentDialog
          open={moveDialogOpen}
          onClose={() => {
            setMoveDialogOpen(false);
            setSelectedEventToMove(null);
          }}
          onConfirm={handleConfirmMove}
          event={selectedEventToMove}
          availableDoctors={
            auth.usuariosAssociados.filter((u) => u.id !== medicoId) || []
          }
        />
      )}

      {conflictDialogOpen && (
        <ConflictResolutionDialog
          open={conflictDialogOpen}
          onClose={() => {
            setConflictDialogOpen(false);
            setConflictData(null);
            setPendingMoveData(null);
          }}
          onConfirm={handleConflictResolution}
          conflictData={conflictData}
          isLoading={false}
        />
      )}
    </div>
  );
}

function renderEventContent(eventInfo) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <div>
        <b>{eventInfo.timeText}</b>
        <i>{eventInfo.event.title}</i>
      </div>
      <div style={{ display: "flex", gap: "4px", alignSelf: "flex-start" }}>
        {/* Presença confirmada. Um ✓ e mais nada: quem confirmou e quando
            estão na lista da secretária, e aqui não há espaço para os ler.
            Não se usa COR DE FUNDO para isto — fundo e borda já significam
            atendido, faltou, avaliação, orçamento e compromisso. */}
        {eventInfo.event.extendedProps.confirmado && (
          <div
            title="O cliente confirmou que vem"
            style={{
              color: "#1b5e20",
              fontSize: "12px",
              fontWeight: "bold",
              lineHeight: 1,
            }}
          >
            ✓
          </div>
        )}
        {eventInfo.event.extendedProps.listaEsperaId && (
          <div
            style={{
              color: "#7B1FA2",
              fontSize: "11px",
              fontWeight: "bold",
            }}
          >
            LE
          </div>
        )}
        {eventInfo.event.extendedProps.observacoesAgendamento && (
          <div
            style={{
              color: "#F57C00",
              fontSize: "11px",
              fontWeight: "bold",
            }}
          >
            Obs
          </div>
        )}
        {/* Código da unidade, no mesmo sítio do LE e do Obs. Só aparece no
            consolidado: com uma unidade escolhida, todas as células são dela.
            Não se usa COR para isto — fundo e borda já significam atendido,
            faltou, avaliação, orçamento e compromisso. */}
        {eventInfo.event.extendedProps.codigoUnidade && (
          <div
            title={eventInfo.event.extendedProps.nomeUnidade || ""}
            style={{
              fontSize: "10px",
              fontWeight: 700,
              padding: "0 4px",
              borderRadius: "4px",
              background: "rgba(255,255,255,0.35)",
            }}
          >
            {eventInfo.event.extendedProps.codigoUnidade}
          </div>
        )}
      </div>
    </div>
  );
}

export default Datatable;
